/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapMutations } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue";
import Group from "vux/src/components/group/index.vue";
import Cell from "vux/src/components/cell/index.vue";
import Search from "vux/src/components/search/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import { getOrderListH5 } from '@/api';
import { orderStatusList, relevanceList, orderSortList, receiptStateList, settlementStateList, evaluateStateList, orderSourceList, timeoutStateList, abnormalStateList, priorityList, orderArchiveType } from '@/constant';
import GeneralOrderList from '@/components/ScrollerList/GeneralOrderList';
import SinglePicker from '@/components/Base/SinglePicker';
export default {
  name: 'Order',
  components: {
    SinglePicker: SinglePicker,
    Group: Group,
    ViewBox: ViewBox,
    Search: Search,
    PopupPicker: PopupPicker,
    XInput: XInput,
    Cell: Cell,
    GeneralOrderList: GeneralOrderList,
    SmyTagSelect: function SmyTagSelect() {
      return import('./components/SmyTagSelect');
    },
    SearchDetail: function SearchDetail() {
      return import('@/components/SearchDetail');
    },
    SmyDatetimeRange: function SmyDatetimeRange() {
      return import('@/components/SmyDatetimeRange');
    },
    SmyTab: function SmyTab() {
      return import('@/components/SmyTab');
    },
    CheckCustomer: function CheckCustomer() {
      return import('@/components/CheckCustomer');
    },
    CheckLinkPerson: function CheckLinkPerson() {
      return import('@/components/CheckLinkPerson');
    },
    CheckUser: function CheckUser() {
      return import('@/components/CheckUser');
    },
    CheckCreator: function CheckCreator() {
      return import('@/components/CheckCreator');
    }
  },
  data: function data() {
    return {
      // 常量
      orderStatusList: orderStatusList,
      relevanceList: relevanceList,
      orderSortList: orderSortList,
      receiptStateList: receiptStateList,
      settlementStateList: settlementStateList,
      evaluateStateList: evaluateStateList,
      orderSourceList: orderSourceList,
      timeoutStateList: timeoutStateList,
      abnormalStateList: abnormalStateList,
      priorityList: priorityList,
      orderArchiveType: orderArchiveType,
      // 筛选列表
      orderTypeList: [],
      // 模板类型
      serverItem: [],
      // 服务项目
      workerlist: [],
      // 服务人员
      orderTagList: [],
      // 工单标签
      orderList: [],
      badgeCountList: {},
      // 时间类型
      timeTypeList: [{
        value: '1',
        name: '创建时间'
      }, {
        value: '2',
        name: '完成时间'
      }, {
        value: '3',
        name: '预约时间'
      }],
      pageIndex: 1,
      pageSize: 12,
      isShowPicker: false,
      showSearchDetail: false,
      isShowTemplate: false,
      // 模板列表
      checkCustomerShow: false,
      // 选择客户
      checkLinkPersonShow: false,
      // 选择联系人
      showSelectSeivice: false,
      // 服务人员
      showSelectCreator: false,
      // 内部创建人
      isSearch: false,
      searchForm: {
        order_state: ''
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'pageReload'])), {}, {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var doc = window.document.documentElement;
      var fontSize = window.getComputedStyle(doc)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    },
    // 需控制返回按钮的字段集合
    isShowKeyMerge: function isShowKeyMerge() {
      return {
        checkCustomerShow: this.checkCustomerShow,
        checkLinkPersonShow: this.checkLinkPersonShow,
        showSelectSeivice: this.showSelectSeivice,
        showSelectCreator: this.showSelectCreator
      };
    }
  }),
  watch: {
    // 左上角返回按钮控制 必须保证所有控制的操作结果是一致的
    isShowKeyMerge: {
      handler: function handler(val, oldVal) {
        var _this = this;

        var _loop = function _loop(key) {
          if (val.hasOwnProperty(key) && val[key] !== oldVal[key]) {
            if (val[key]) {
              _this.$setLeft({
                control: true,
                // 控制按钮
                onSuccess: function onSuccess() {
                  _this.$set(_this.$data, key, false);
                }
              });
            } else {
              _this.$setLeft({
                control: false
              }); // 取消控制

            }
          }
        };

        for (var key in val) {
          _loop(key);
        }
      },
      deep: true
    },
    // ——————————————左上角返回按钮控制——————————————
    'searchForm.timeType': {
      handler: function handler(val) {
        this.searchForm.takeStart = '';
        this.searchForm.takeEnd = '';
        this.searchForm.visitStart = '';
        this.searchForm.visitEnd = '';
        this.searchForm.finishStart = '';
        this.searchForm.finishEnd = '';
      }
    },
    isShowTemplate: function isShowTemplate(val) {
      if (val) {
        this._showHomebottomBar(false);
      } else {
        this._showHomebottomBar(true);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_showHomebottomBar', '_pageReload', '_orderSearch'])), {}, {
    loadList: function loadList() {
      var _this2 = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var operation = arguments.length > 1 ? arguments[1] : undefined;

      if (reset) {
        this.pageIndex = 1;
        this.$vux.loading.show({
          text: '加载中...'
        });
      }

      return new Promise(function (resolve, reject) {
        var data = {
          pageNo: _this2.pageIndex,
          pageSize: _this2.pageSize,
          id: localStorage.getItem('id'),
          keyword: _this2.searchForm.keyword
        };
        getOrderListH5(data).then(function (res) {
          var _res$hdProjectProduct2, _res$hdProjectProduct3;

          res = res.data; // 不重置数据累计

          if (!reset) {
            _this2.orderList = Object.freeze([].concat(_toConsumableArray(_this2.orderList), _toConsumableArray(res.hdProjectProduct.items)));
          } else {
            var _res$hdProjectProduct;

            _this2.orderList = Object.freeze(((_res$hdProjectProduct = res.hdProjectProduct) === null || _res$hdProjectProduct === void 0 ? void 0 : _res$hdProjectProduct.items) || []);
            setTimeout(function () {
              _this2.$vux.loading.hide();
            }, 300); // 搜索时滚动至顶部

            if (operation === 'search') {
              _this2.$refs.orderList.scrollToTop();

              _this2.$point('ORD0002');
            }
          }

          resolve(); // 判断是否有新数据

          if (((_res$hdProjectProduct2 = res.hdProjectProduct) === null || _res$hdProjectProduct2 === void 0 ? void 0 : _res$hdProjectProduct2.items.length) < _this2.pageSize) {
            setTimeout(function () {
              _this2.$refs['orderList'] && _this2.$refs['orderList'].disablePullup();
            }, 100);
          }

          if (((_res$hdProjectProduct3 = res.hdProjectProduct) === null || _res$hdProjectProduct3 === void 0 ? void 0 : _res$hdProjectProduct3.items.length) === _this2.pageSize) {
            setTimeout(function () {
              _this2.$refs['orderList'] && _this2.$refs['orderList'].enablePullup();
            }, 100);
          }
        });
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this3 = this;

      this.loadList(true).then(function () {
        _this3.$refs['orderList'] && _this3.$refs['orderList'].donePulldown();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this4 = this;

      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {
        _this4.$refs['orderList'] && _this4.$refs['orderList'].donePullup();
      });
    },
    // 单选数据源重置
    pickerDataReset: function pickerDataReset() {},
    tabChange: function tabChange(val) {
      this.loadList(true, 'search');
    },
    // 重置搜索条件
    resetSearchForm: function resetSearchForm(val) {
      this.isSearch = false;
      this.loadList(true, val);
    },
    initData: function initData() {},
    setMenu: function setMenu() {}
  }),
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    try {
      this.$DingTalk.biz.navigation.setRight({
        show: false
      });
    } catch (error) {
      console.log(error);
    }

    this._showHomebottomBar(true);

    this.isShowTemplate = false;
    this.showSearchDetail = false;
    next();
  },
  // 页面缓存
  activated: function activated() {
    if (this.pageReload.order) {
      // 切换角色时筛选列表重置
      if (this.pageReload.orderSearch) {
        this.searchForm.type = '1';
        this.resetSearchForm();

        this._pageReload({
          orderSearch: false
        });
      } else {
        this.loadList(true);
      }

      this._pageReload({
        order: false
      });
    }

    this.initData();
    this.setMenu();
  },
  created: function created() {
    this._pageReload({
      order: true
    });
  }
};